import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from "@angular/core";
import { Providers, ProvidersList, IproviderRowData } from "../../../enums/providers";

@Component({
    selector: "app-provider-graphical-select",
    template: require('./provider-graphical-select.component.html'),
    styles: [require('./provider-graphical-select.component.scss')]
})
export class ProviderGraphicalSelectComponent implements OnInit {
    @Output("update")
    change: EventEmitter<Providers> = new EventEmitter<Providers>();

    @ViewChild('content') elementView: any;
    
    public _current: Providers = Providers.DEMO;
    @Input() public set current(value: Providers) {
        this._current = value;
        this.setCurrentState(value);
    }

    private _isDebug: boolean = false;
    public get isDebug(): boolean {
        return this._isDebug;
    }

    @Input() public set isDebug(value: boolean) {
        this._isDebug = value;
        // this.providerlist = ProvidersList().filter(v => {
        //     if (!this.isDebug && v.id == Providers.GAIN) {
        //         return false;
        //     }
        //     return true;
        // });
    }

    //@Input() set isDebug:boolean = false;

    public providerlist = ProvidersList();

    public get current(): Providers {
        return this._current;
    }

    private _waiting: boolean = false;
    public get waiting(): boolean {
        return this._waiting;
    }

    @Input()
    public set waiting(value: boolean) {
        if (value == false) {
            this.setCurrentState(this.current);
        }
        this._waiting = value;
    }

    public setCurrentState(value: Providers) {
        let current = this.providerlist.filter(v => {
            return v.id == value;
        });

        this.currentValue = current[0];
    }

    private _currentValue?: IproviderRowData = this.providerlist[0];
    public get currentValue(): IproviderRowData | undefined {
        return this._currentValue;
    }
    public set currentValue(value: IproviderRowData | undefined) {
        this._currentValue = value;
    }

    constructor() {}

    public setAvtiveProvider(id: Providers) {
        let current = this.providerlist.filter(v => {
            return v.id == id;
        });

        this.currentValue = current[0];
        this.increment();
    }

    increment() {
        if (this.currentValue) this.change.emit(this.currentValue.id);
    }

    public get isSmallFont():boolean
    {
        if(this.elementView.nativeElement)
        {
          let width = this.elementView.nativeElement.offsetWidth
          //console.log(width);
          if(width<89)
          {
              return true
          }
        }
        

        return false
    }


    ngOnInit() {}
}
